import React, { useContext, useEffect, useState } from 'react'

import CheckoutLayout from '../../../layouts/buy/CheckoutLayout'
import { NonEmptyCartContext } from '../../../lib/cart/context'
import useCheckoutNavBarOptionValue from '../../../lib/cart/hooks/useCheckoutNavBarOptionValue'
import useLegalAgreementsGuard from '../../../lib/cart/hooks/useLegalAgreementsGuard'
import usePatientOnboardingCompleteGuard from '../../../lib/cart/hooks/usePatientOnboardingCompleteGuard'
import useRegistrationGuard from '../../../lib/cart/hooks/useRegistrationGuard'
import { useTestKitProducts } from '../../../lib/products/hooks/useTestKitProducts'
import { testKitDelayedBilling } from '../../../utils/buy/paymentTools'
import Spinner from '../../Spinner'
import { ApplyRewards } from './ApplyRewards'
import NoPaymentDetailsRequiredContainer from './NoPaymentDetailsRequiredContainer'
import PaymentDetailsContainer from './PaymentDetailsContainer'

const PaymentContainer: React.FC = () => {
  const { loadingRedirect, shouldRedirect } = useRegistrationGuard()
  usePatientOnboardingCompleteGuard()
  useLegalAgreementsGuard()
  const { navBarOptionValue, loading: loadingNavBarOptions } =
    useCheckoutNavBarOptionValue('payment')
  const customerCart = useContext(NonEmptyCartContext)
  const { isTestKitSku } = useTestKitProducts()
  const [showPaymentDetails, setShowPaymentDetails] = useState(
    !!customerCart.prices?.grand_total?.value,
  )

  const delayedBillingRequired = testKitDelayedBilling({ cart: customerCart, isTestKitSku })

  useEffect(() => {
    if (customerCart.prices?.grand_total?.value || delayedBillingRequired) {
      setShowPaymentDetails(true)
    } else {
      setShowPaymentDetails(false)
    }
  }, [customerCart.prices?.grand_total?.value, delayedBillingRequired])

  if (loadingRedirect || shouldRedirect || loadingNavBarOptions) {
    return <Spinner loading />
  }

  return (
    <CheckoutLayout checkoutNavigationBarTabValue={navBarOptionValue}>
      <ApplyRewards />
      {showPaymentDetails ? <PaymentDetailsContainer /> : <NoPaymentDetailsRequiredContainer />}
    </CheckoutLayout>
  )
}

export default PaymentContainer
